import { render, staticRenderFns } from "./editNewspaperBulky.vue?vue&type=template&id=3e0b36c7&scoped=true&"
import script from "./editNewspaperBulky.vue?vue&type=script&lang=js&"
export * from "./editNewspaperBulky.vue?vue&type=script&lang=js&"
import style0 from "./editNewspaperBulky.vue?vue&type=style&index=0&id=3e0b36c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0b36c7",
  null
  
)

export default component.exports